// 菜单
const menu = {
  'common_menu_home': { cn: '首页', en: 'Home', kr: '' },
  'common_menu_document': { cn: '文档中心', en: 'Document', kr: '' },
  'common_menu_workbench': { cn: '工作台', en: 'Workbench' },
  'common_menu_buy': { cn: '购买', en: 'Buy' },
  'common_menu_edit': { cn: '编辑', en: 'Edit' },
  'common_menu_website': { cn: '官网', en: 'Website' },
  'common_menu_service_management': { cn: '服务管理', en: 'Service management' },
  'common_menu_interface_yet': { cn: '暂无接口数据', en: 'No interface data yet' },
  'common_menu_confirm_an_order': { cn: '确认订单', en: 'Confirm an order' },
  'common_menu_scan2pay': { cn: '扫码支付', en: 'Scan to pay' },
  'common_menu_choose_platform': { cn: '选择平台', en: 'Choose the platform' },
  'common_menu_select_Renewals_package': { cn: '选择续费包', en: 'Select renewal packages' },
  'common_menu_select_r_package': { cn: '选择{0}续费/加油包', en: 'Select {0} renewal/refueling package' },
  'common_menu_select_erp_order_consumption': { cn: 'ERP订单消耗', en: 'ERP order consumption' },
  'common_menu_select_order_consumption': { cn: '订单消耗', en: 'order consumption' },
  'common_menu_oreder_consumption_details': { cn: '订单消耗明细', en: 'Order consumption details' },
  'common_menu_Renewal_package': { cn: '续费包', en: 'Renewal package' },
  'common_menu_select_Renewal_package': { cn: '选择续费包', en: 'Select renewal package' },
  'common_menu_select_up_package': { cn: '选择升级包', en: 'Select upgrade package' },
  'common_menu_renDet': { cn: '服务详情', en: 'Service details' },
  'common_menu_Successful_appointment': { cn: '预约成功', en: 'Successful appointment' },
  'common_menu_my_doc_feedback': { cn: '我的文档反馈', en: 'My Document feedback' },
  'common_menu_my_doc_fankui': {
    cn: '页面默认显示您注册时填写的手机号与邮箱，若您需要更换联系方式，可在备注中说明',
    en: 'Pages display the mobile phone number and email address by default. If the contact information changes, take place in the remarks'
  },
  'common_menu_video_details': { cn: '视频详情', en: 'Video details' },
  // 'common_menu_': { cn: '', en: '' },
  'common_menu_': { cn: '', en: '' }
}

// 连词|动词|承接词|量词|介词|名词
const conj = {
  // 动词
  'common_conj_to': { cn: '去', en: 'Go to ' },
  'common_conj_and': { cn: '和', en: ' and ' },
  'common_conj_please': { cn: '请', en: 'Please ' },
  'common_conj_look': { cn: '{0}看看', en: '{0}See' },
  'common_conj_change': { cn: '修改', en: 'Change ' },
  'common_conj_save': { cn: '保存', en: 'Save ' },
  'common_conj_binding': { cn: '绑{0}定', en: 'Binding ' },
  'common_conj_unbind': { cn: '解绑', en: 'Unbind' },
  'common_conj_replace': { cn: '更{0}换', en: 'Replace ' },
  // 承接词
  'common_conj_immediately': { cn: '立即', en: 'Immediately ' },
  'common_conj_type': { cn: '类型', en: 'type ' },
  'common_conj_all': { cn: '全部{0}', en: 'All {0}' },
  'common_conj_successfully': { cn: '{0}成功', en: '{0} successfully' },
  'common_conj_successfully_only': { cn: '成功', en: 'successfully' },
  'common_conj_delete_successfully_only': { cn: '删除成功', en: 'delete successfully' },
  // 名词
  'common_conj_eccang': {
    cn: '深圳市易仓科技有限公司',
    en: 'Shenzhen Eccang Technology Co., Ltd'
  },
  'common_conj_time_duration': { cn: '时长', en: 'Time duration' },
  'common_conj_enterprise_main': { cn: '主企业', en: 'Main Company' },
  'common_conj_enterprise_child': { cn: '子企业', en: 'Child Company' },
  'common_conj_buy': { cn: '{0}购买', en: '{0}Buy' },
  'common_conj_mobile': { cn: '手机{0}', en: 'Mobile {0}' },
  'common_conj_system': { cn: '系统', en: 'System ' },
  'common_conj_port': { cn: '接口', en: 'port ' },
  'common_conj_WeChat': { cn: '微信', en: 'WeChat' },
  'common_conj_WeChat_Pay': { cn: '微信支付', en: 'WeChat Pay' },
  'common_conj_Alipay': { cn: '支付宝', en: 'Alipay ' },
  'common_conj_pay': { cn: '支付', en: 'Pay ' },
  'common_conj_prompt': { cn: '提示', en: 'prompt ' },
  'common_conj_info': { cn: '基本信息', en: 'INFO ' },
  'common_conj_man': { cn: '男', en: 'Man' },
  'common_conj_woman': { cn: '女', en: 'Woman' },
  'common_conj_more': { cn: '更多', en: 'More' },
  'common_conj_title': { cn: '标题', en: 'Title' },
  'common_conj_list': { cn: '列表', en: 'List' },
  'common_conj_platform': { cn: '平台', en: 'Platform' },
  'common_conj_time': { cn: '时间', en: 'Time' },
  'common_conj_email': { cn: '{0}邮箱', en: '{0}Mailbox' },
  'common_conj_address': { cn: '{0}地址', en: '{0}Address' },
  'common_conj_date': { cn: '日期', en: 'Date' },
  'common_conj_contact': { cn: '联系我们', en: 'Contact Us' },
  'common_conj_nothing': { cn: '无', en: '' },
  'common_conj_online': { cn: '专人在线演示解答', en: 'Online answer in Demo' },
  'common_conj_understand': { cn: '快速了解产品功能使用', en: 'Quickly understand product functions' },
  'common_conj_provide': { cn: '提供专属解决方案', en: 'Provide exclusive solution' },
  'common_conj_effective': { cn: '请留下您的有效联系方式，我们的业务专家会及时联系您，与您确定业务交流和系统演示的时间，祝您事业蒸蒸日上！', en: 'Please leave your effective contact information, our business experts will contact you in time, with you to determine the time of business communication and system demonstration, I wish you a prosperous career!' },
  'common_conj_appointment': { cn: '预约', en: 'Make an appointment' },
  'common_conj_helpDoc': { cn: '帮助文档', en: 'help documentation' },
  'common_刷新': { cn: '刷新', en: 'Refresh' },
  'common_conj_put': { cn: '收起', en: 'Put Away', kr: '치워' }
}

// 常用按钮
const btn = {
  'common_home_announcement_type0': { cn: '全部', en: 'All' },
  'common_btn_back_home': { cn: '返回首页', en: 'Back to homepage' },
  'common_btn_login_out': { cn: '退出登录', en: 'Login Out' },
  'common_btn_switch_comp': { cn: '切换企业', en: 'Switch Company' },
  'common_btn_submit': { cn: '提交', en: 'Submit' },
  'common_btn_confirm': { cn: '确定', en: 'Confirm' },
  'common_btn_confirm2': { cn: '确认', en: 'Confirm' },
  'common_btn_close': { cn: '关闭', en: 'Close' },
  'common_btn_cancel': { cn: '取消', en: 'Cancel' },
  'common_btn_handle': { cn: '操作', en: 'Option' },
  'common_btn_newplus': { cn: '新增{0}', en: 'Add {0}' },
  'common_btn_add': { cn: '添加{0}', en: 'Add {0}' },
  'common_btn_edit': { cn: '编辑{0}', en: 'Edit {0}' },
  'common_btn_edit2': { cn: '修改{0}', en: 'Edit {0}' },
  'common_btn_select': { cn: '选择{0}', en: 'Select {0}' },
  'common_btn_delete': { cn: '删除', en: 'Del' },
  'common_btn_import': { cn: '导入', en: 'Import' },
  'common_btn_search': { cn: '查询', en: 'Search' },
  'common_btn_auth': { cn: '授权', en: 'Authorization' },
  'common_btn_choose_file': { cn: '选择文件', en: 'Choose File' },
  'common_btn_ulog': { cn: '操作日志', en: 'ULog' },
  'common_btn_view_look': { cn: '查看', en: 'Look over' },
  'down_暂不支持': { cn: '暂不支持', en: 'Not supported yet' },
  'common_btn_view_details': { cn: '查看详情', en: 'View details' },
  'common_btn_renew': { cn: '{0}续费', en: '{0}Renew' },
  'common_btn_buy': { cn: '{0}购买', en: '{0}Buy' },
  'common_btn_upgrade': { cn: '升级', en: 'Upgrade' },
  'common_btn_immediately_opened': { cn: '立即开通', en: 'Immediately Opened' },
  'common_btn_immediately_openedDocument': { cn: '权限开通操作文档', en: 'Permission opening operation document' },
  'common_btn_immediately_buy': { cn: '立即购买', en: 'Immediately Buy' },
  'common_btn_i_know': { cn: '我知道了', en: 'I Know' },
  'common_btn_know_more': { cn: '了解更多', en: 'Know more about' },
  'common_btn_send_ver': { cn: '发送验证码', en: 'Send Code' },
  'common_btn_upload_avatar': { cn: '上传头像', en: 'Upload avatar' },
  'common_upload': { cn: '上传', en: 'Upload' },
  'common_submint_seccess': { cn: '提交成功', en: 'Submission successful' },
  'common_btn_download_attachment': { cn: '下载附件', en: 'Download Attachment' },
  'common_btn_send_ver_later': { cn: '{0}S后重发', en: '{0}s later' },
  'common_btn_appointment_immediately': { cn: '立即预约', en: 'To make an appointment immediately' },
  'common_btn_binding_ding': { cn: '绑定钉钉', en: 'Binding Ding Talk' },
  'common_btn_next_tiao': {
    cn: '下一条',
    en: 'Next {0}',
    kr: '다음'
  },
  'common_btn_by_time_charge': { cn: '按使用时间计费', en: 'Charge by time of use' },
  'common_btn_by_order_charge': { cn: '按单计费', en: 'Charge by order' }
}

// 状态
const status = {
  'common_status_page_jump': { cn: '页面跳转中', en: 'Page jumping' },
  'common_status_page_loading': { cn: '加载中', en: 'Loading' },
  'common_status_page_requesting': { cn: '请求中', en: 'Requesting' },
  'common_status_page_querying': { cn: '查询中', en: 'Querying' },
  'common_status_failure': { cn: '已失效', en: 'Failure' },
  'common_status_normal': { cn: '正常', en: 'Normal' },
  'common_status_off_stream': { cn: '已停用', en: 'Off Stream' },
  'common_status_exhausted': { cn: '已用完', en: 'Exhausted' },
  'common_status_about_to_exhausted': { cn: '即将用完', en: 'About to Exhausted' },
  'common_status_updating': { cn: '升级中', en: 'Updating' },
  'common_status_abandon': { cn: '已废弃', en: 'Abandon' },
  'common_status_wait_deployment': { cn: '待部署', en: 'Wait Deployment' },
  'common_status_deployment': { cn: '部署中', en: 'Deployment' },
  'common_status_deployment_failure': { cn: '部署失败', en: 'Deployment Failure' },
  'common_status_expired': { cn: '过期', en: 'Expired' },
  'common_status_about_to_expire': { cn: '即将过期', en: 'About to Expire' },
  'common_status_binging_success': { cn: '绑定成功', en: 'Binding success' },
  'common_status_unbinging_success': { cn: '解绑成功', en: 'Unbundling success' },
  'common_status_uploading': { cn: '正在上传', en: 'Uploading' },
  'common_status_edit_pd_success': { cn: '修改密码成功', en: 'Password changed successfully' },
  'common_status_sure_to_w': { cn: '确认{0}吗', en: 'Are you sure to {0}' },
  'common_status_save_successfully': { cn: '保存成功', en: 'Save successfully' },
  'common_status_be_authorized': { cn: '已授权', en: 'Be authorized' },
  'common_status_unauthorized': { cn: '未授权', en: 'Unauthorized' }

}

// 表单常用名称
const form = {
  'common_form_user_name': { cn: '用户名', en: 'UserName' },
  'common_form_nick_name': { cn: '昵称', en: 'NickName' },
  'common_form_real_name': { cn: '姓名', en: 'Name' },
  'common_form_Country-region': { cn: '国家/地区', en: 'Country/region' },
  'common_form_Location': { cn: '所在地区', en: 'Location' },
  'common_form_detailed_address': { cn: '详细地址', en: 'Detailed address' },
  'common_form_sex': { cn: '性别', en: 'Sex' },
  'common_form_phone': { cn: '手机号', en: 'Phone' },
  'common_form_comp_name': { cn: '公司名称', en: 'Company name' },
  'common_form_comp_area': { cn: '公司所在区域', en: 'Company area' },
  'common_form_email': { cn: '邮箱', en: 'Email' },
  'common_form_OperationContent': { cn: '操作内容', en: 'Operation content' },
  'common_form_AppliedContent': { cn: '应用名称', en: 'Application name' },
  'common_form_remark': { cn: '备注', en: 'Remark' },
  'common_form_remark_optional': { cn: '选填, 其他内容可在备注中', en: 'Optional, other content can be in the remarks' },
  'common_form_third_account': { cn: '第三方账号', en: 'Third party account' },
  'common_form_select_pro_req': { cn: '选择产品需求', en: 'Select product requirements' },
  'common_form_login_name_or_phone': { cn: '用户名或手机号', en: 'User name or mobile phone number' },
  'common_form_login_pd': { cn: '登录密码', en: 'Login password' },
  'common_form_identifying_code': { cn: '图形验证码', en: 'Identifying code' },
  'common_form_customer_code': { cn: '客户代码', en: 'Customer code' },
  'common_form_please_enter': { cn: '请输入{0}', en: 'Please enter {0}' },
  'common_form_please_fillin': { cn: '请填写{0}', en: 'Please fill in {0}' },
  'common_form_please_select': { cn: '请选择{0}', en: 'Please select {0}' },
  'common_form_maximum_char': { cn: '最多{0}个字符', en: 'maximum {0} characters' },
  'common_form_enter_words_than': { cn: '输入{1}，不超过50个字', en: 'Enter a {1} of no more than {0} words' },
  'common_form_files_larger_then': { cn: '文件大于{0}哦', en: 'Files larger than {0}' },
  'common_form_upload_please': { cn: '请上传{0}文件', en: 'Please upload {0} file' },
  'common_form_cannot_empty_by': { cn: '{0}不能为空', en: 'The {0} cannot be empty' },
  'common_form_select_All': { cn: '全选', en: 'Select all' },
  'common_form_deselect_All': { cn: '全不选', en: `Deselect all` },
  'authority_account_操作成功': { cn: '操作成功', en: 'succeess' },
  'authority_account_succeeded': { cn: '编辑成功', en: 'Edit succeeded' },
  'authority_account_successfullys': { cn: '新增成功', en: 'Added successfully' }
}

// 登录
const login = {
  'common_login': { cn: '登录', en: 'Login' },
  'common_login_other_login_methods': { cn: '其他登录方式', en: 'Other login methods' },
  'common_login_first_bind_set_phone': { cn: '首次登录需绑定手机号及设置密码', en: 'The first time you log in, you need to bind the phone number and set the password' },
  'common_login_return_user_login': { cn: '返回用户登录', en: 'Return user login' },
  'common_login_erp1_cust_login': { cn: 'ERP1.0客户登录', en: 'ERP1.0 customer login' },
  'common_login_register': { cn: '注册', en: 'Register' },
  'common_login_dingtalk_reading': { cn: '钉钉拉取中，请稍后一下', en: 'The Dingtalk is reading, please wait a moment' },
  'common_login_QR_wrong': { cn: '二维码有误，请稍后在试', en: 'The QR code is wrong, please try again later' },
  'common_login_click_get': { cn: '点击重新获取', en: 'Click on the get' },
  'common_login_forget_password': { cn: '忘记密码', en: 'Forget password' },
  'common_login_I_read_agress': { cn: '我已阅读并同意', en: 'I have read and agree to' },
  'common_login_阅读并同意': { cn: '阅读并同意', en: 'Read and agree' },
  'common_login_ServiceAgreement': { cn: '服务协议', en: 'Service Agreement' },
  'common_login_PrivacyPolicy': { cn: '隐私政策', en: 'Privacy Policy' },
  'common_conj_and': {
    cn: '和',
    en: ' and ',
    kr: '와'
  },
  'common_login_ckeck_agreement': { cn: '请查看并勾选用户协议', en: 'Select the user agreement' },
  'common_login_ckeck_产品需求不能为空': { cn: '产品需求不能为空', en: 'Product demand cannot be empty' },
  'common_login_ckeck_请选择完整的地区': { cn: '请选择完整的地区', en: 'Select the whole region' },
  // 'common_login_': { cn: '注册', en: '' },
  // 'common_login_': { cn: '注册', en: '' },
  // 'common_login_': { cn: '注册', en: '' },
  // 'common_login_': { cn: '注册', en: '' },
  // 'common_login_': { cn: '注册', en: '' },
  // 'common_login_': { cn: '注册', en: '' },
  // 'common_login_': { cn: '注册', en: '' },
  'common_login_': { cn: '注册', en: '' }
}

// 购买
const buy = {
  'common_buy_free': { cn: '免费', en: 'Free' },
  'common_buy_standard': { cn: '标准版', en: 'Standard' },
  'common_buy_flagship': { cn: '旗舰版', en: 'Flagship' },
  'common_buy_best': { cn: '如意版', en: 'Best' }
}

// 首页
const home = {
  'page.home.login': { cn: '登录{0}', en: 'Login {0}' },
  'page.home.last_login_time': { cn: '上次登录时间', en: 'Last Login Time' },
  'page.home.unread_message': { cn: '未读消息', en: 'Unread Message' },
  'page.home.coupons': { cn: '优惠券', en: 'Coupons' },
  'page.home.my_orders': { cn: '我的订单', en: 'My Orders' },
  'page.home.christmas_days': { cn: '距离{0}，还有{1}天', en: '{0} is {1} days away' },
  'page.home.phone_not_currently': { cn: '当前还未绑定手机号', en: 'The phone number is not currently bound' },
  'page.home.phone_currently_to_reset': {
    cn: '绑定手机号可以用于登录帐号，重置密码或其他安全验证',
    en: 'The binding phone number can be used to log in to an account, reset a password or other security verification'
  },
  'page.home.help.center': { cn: '帮助中心', en: 'Help center' },
  // 已开通系统
  'common_home_buy': { cn: '更多套餐购买', en: 'Buy more packages' },
  'common_home_open_system': { cn: '已开通系统', en: 'Open system' },
  'common_home_into_system': { cn: '进入系统', en: 'Into system' },
  'common_home_product_service_title': { cn: '产品/服务名称', en: 'Product/Service' },
  'common_home_valid_until': { cn: '有效期至', en: 'Valid until' },
  'common_home_r_undrawn': { cn: '剩余额度', en: 'Remaining undrawn' },
  'common_home_rs_undrawn': { cn: '剩余单量', en: 'Remaining single-amount' },
  'common_home_valid_of': { cn: '有效期', en: 'Period of validity' },
  'common_home_unlimited_while': { cn: '无限制，用完即止', en: 'Unlimited while stock lasts' },
  'common_home_current_account_no_permissions': {
    cn: '当前账号无权限，请联系管理员开通',
    en: 'The current account has no permissions, please contact the administrator to open it'
  },
  'common_home_out_of_service': { cn: '服务已停用', en: 'Service out of service' },
  'common_home_deployment_wait_time': {
    cn: '服务正在部署中，请稍等5-10分钟后，再来访问系统！',
    en: 'The service is being deployed, please wait for 5-10 minutes and then come back to access the system!'
  },
  'common_home_announcement': {
    cn: '{0}公告{1}',
    en: '{0}Announcement {1}',
    kr: '{0}공지사항{1}'
  },

  // 公告
  'common_home_announcement_type1': { cn: '系统通知', en: 'Systematic' },
  'common_home_announcement_type2': { cn: '版本发布', en: 'Release version' },
  'common_home_announcement_type3': { cn: '功能更新', en: 'Update function' },
  'common_home_announcement_type4': { cn: '紧急通知', en: 'Emergency' },
  'common_home_announcement_type5': { cn: '其他', en: 'Other' },
  'common_home_param_error_nont_download': { cn: '参数错误，下载图片失败', en: 'Parameter error, download image failed' },

  // 安全设置
  'common_home_security_settings': { cn: '安全设置', en: 'Security Settings' },
  'common_home_login_password': { cn: '{0}登录密码', en: '{0}Login Password' },
  'common_home_login_password_info_p': {
    cn: '登录密码可以用于登录帐号，重置密码或其他安全验证',
    en: 'The login password can be used to login the account, reset the password or other security authentication'
  },
  'common_home_currently_no_mailbox': { cn: '当前尚未绑定邮箱', en: 'No email is currently bound' },
  'common_home_mailbox_p': {
    cn: '绑定邮箱可以用于登录帐号，重置密码或其他安全验证',
    en: 'The bound mailbox can be used to log in to the account, reset the password or other security verification'
  },

  // 安全设置 -> 邮箱modal
  'common_home_enter_previous_password': { cn: '请输入旧密码', en: 'Enter previous passwords' },
  'common_home_set_password_8-16': { cn: '设置8至16位密码', en: 'Set a 8 to 16-digit password' },
  'common_home_set_password_validator_8-16_num_case': {
    cn: '请输入8至16位字母大小写加数字组合密码',
    en: 'Please enter 8 to 16 characters case and number combination password'
  },
  'common_globalcomp_自定义列设置': {
    cn: '自定义列设置',
    en: 'Custom column settings',
    kr: '맞춤 열 설정'
  },
  'common_globalcomp_选择列表字段': {
    cn: '选择列表字段',
    en: 'Pick list field',
    kr: '선택 목록 필드'
  },
  'common_globalcomp_已选列表字段排序': {
    cn: '已选列表字段排序',
    en: 'Sort selected list fields',
    kr: '선택한 목록 필드 정렬'
  },
  'common_globalcomp_恢复默认': {
    cn: '恢复默认',
    en: 'Reset',
    kr: '초기화'
  },
  'common_form_select_All': {
    cn: '全选',
    en: 'Select all',
    kr: '전체 선택'
  },
  'common_btn_cancel': {
    cn: '取消',
    en: 'Cancel',
    kr: '취소'
  },
  'common_home_login_password_again': { cn: '再次输入验证码', en: 'Enter the verification code again' },
  'common_home_enter_login_password': { cn: '请输入登录密码', en: 'Enter the login password' },
  'common_home_enter_email_vercode': { cn: '请输入邮箱中的验证码', en: 'Enter the email verification code' },
  'common_home_enter_email_address': { cn: '请输入邮箱地址', en: 'Enter the email address' },
  'common_home_enter_email_verification': { cn: '请输邮箱验证码', en: 'Please enter email verification code' },
  'common_home_enter_new_email_address': { cn: '请输入新的邮箱', en: 'Enter new email' },
  'common_home_enter_new_verCode': { cn: '请输入6位验证码', en: 'Please enter a 6 digit verification code' },
  'common_home_enter_email_address_format_incorrect': { cn: '邮箱格式不正确！', en: 'Incorrect email format' },
  'common_home_enter_email_address_format_numbers': { cn: '设置8至16位包含大小写字母及数字的密码', en: 'Set a password of 8 to 16 digits containing upper and lower case letters and numbers' },
  'common_home_enter_email_address_format_again': { cn: '请再次输入密码', en: 'Please enter your password again' },
  'common_home_user_login': { cn: '返回用户登录', en: 'Return user login' },
  'common_home_user_successful': { cn: '密码重置成功', en: 'Password reset successful' },
  'common_home_user_information_safe': { cn: '请妥善保管您的账户信息', en: 'Please keep your account information' },
  'common_home_user_immediately': { cn: '立即登录', en: 'Login immediately' },
  'common_home_user_email_back': { cn: '邮箱找回', en: 'By Email' },
  'common_home_user_phone_number': { cn: '找回密码', en: 'Retrieve password' },
  // 'common_home_user_hong_kong': { cn: '中国香港', en: 'Hong Kong, China' },
  // 'common_home_user_macau': { cn: '中国澳门', en: 'Macau, China' },
  // 'common_home_user_taiwan': { cn: '中国台湾', en: 'Taiwan, China' },
  // 'common_home_user_states': { cn: '美国', en: 'The United States' },
  // 'common_home_user_australia': { cn: '澳大利亚', en: 'Australia' },
  // 'common_home_user_britain': { cn: '英国', en: 'Britain' },
  'common_home_user_mobile_phone': { cn: '请输入您的用户名或者手机号', en: 'Please enter your user name or mobile phone number' },
  'common_home_user_your_password': { cn: '请输入您的密码', en: 'Please enter your password' },
  'common_home_user_emit_address': { cn: '请输入您的邮箱', en: 'Please enter your email address' },
  'common_home_user_emit_format': { cn: '邮箱格式有误哦', en: 'Incorrect email format' },
  'common_home_user_mobile_phone2': { cn: '请输入您的手机号码', en: 'Please enter your mobile phone number' },
  'common_home_user_verification_code': { cn: '请输入图片验证码', en: 'Please enter the image verification code' },
  'common_home_user_dont_match': { cn: '两次密码输入不一致哦', en: 'The two passwords dont match' },
  'common_home_user_error': { cn: '错误', en: 'Error' },
  'common_home_user_again_later': { cn: '请求出现错误，请稍后再试', en: 'There was an error in the request. Please try again later' },
  'common_home_user_mobile_phone3': { cn: '请输入完整的手机号码', en: 'Please enter your complete cell phone number' },
  'common_home_user_four_digit': { cn: '请输入四位数字验证码', en: 'Please enter a four-digit verification code' },
  'common_home_user_right_format': { cn: '邮箱邮箱格式有误哦', en: 'The email box is not in the right format' },
  // 安全设置 - 修改密码modal
  'common_home_enter_conf_pws': { cn: '确认密码', en: 'Please enter a confirmation password' },
  'common_home_enter_conf_pw': { cn: '请输入确认密码', en: 'Please enter a confirmation password' },
  'common_home_enter_two_different_pd': { cn: '两次密码输入不相同', en: 'Two different password input' },

  // 安全设置 - 绑定手机号码
  'common_home_binding_mobile': { cn: '绑定手机号', en: 'Binding mobile number' },
  'common_home_enter_mobile': { cn: '请输入手机号码', en: 'Please enter your mobile number' },
  'common_home_enter_code_of_right': { cn: '请输右侧验证码', en: 'Please enter the verification code on the right' },
  'common_home_enter_message_code': { cn: '请输入短信验证码', en: 'SMS code' },
  'common_home_mobile_reset_or_security': { cn: '手机号可用于密码重置或安全验证', en: 'The phone number can be used for resetting password or verifying security' }
  // 'common_home_': {cn: '', en: ''},
}

// 公共组件 （header + footer + menu + components）
const globalcomp = {
  'common_globalcomp_unusable_enterprise': { cn: '无可用企业，', en: 'Unusable enterprise,' },
  'common_globalcomp_create_your_company': {
    cn: '您可以创建自己的企业或让公司管理员将您添加为子账号',
    en: 'You can create your own business or have your company administrator add you as a child account'
  },
  'common_globalcomp_to_create': { cn: '去创建', en: 'To create' },
  'common_globalcomp_to_create_company': { cn: '创建自己的企业', en: 'Start your own business' },
  'common_globalcomp_to_create_certification': { cn: '去认证', en: 'Authentication' },
  'common_globalcomp_own_enterprise': { cn: '自己的企业', en: "one's own enterprise" },
  'common_globalcomp_select_area': { cn: '请选择地区', en: 'Please select an area' },
  'common_globalcomp_select_organization_structure': { cn: '请选择组织架构', en: 'Please select an organization structure' },
  'common_globalcomp_exit_login_title': { cn: '退出确认', en: 'Exit the confirmation' },
  'common_globalcomp_exit_login_info': { cn: '确定退出登录吗？', en: 'Are you sure to log out?' },
  'common_globalcomp_warm_prompt': { cn: '温馨提示', en: 'Warm prompt' },
  'common_globalcomp_warm_customer': { cn: '微信公众号', en: 'Customer service' },
  'common_globalcomp_network_anomaly': { cn: '网络异常', en: 'Network anomaly' },
  'common_globalcomp_account_log_out': { cn: '账号已退出', en: 'Account has been logged out' },
  'common_globalcomp_request_error': { cn: '请求出现错误，请稍后再试', en: 'There was an error in the request. Please try again later' },
  'common_globalcomp_login_expired': { cn: '登录过期，请重新登录', en: 'Login expired, please login again' },
  'common_globalcomp_network_server_exception': {
    cn: '您的网络发生异常，无法连接服务器',
    en: 'There is an exception on your network and you cannot connect to the server'
  }
}

// 侧边栏 （联系方式 + 回到顶部）
const sidebar = {
  'common_sidebar_to_top': { cn: '回到顶部', en: 'Back to top' },
  'common_sidebar_telephone_counseling': { cn: '电话咨询', en: 'Telephone counseling' },
  'common_sidebar_pre_sales_con': { cn: '售前咨询', en: 'Pre-sales consulting' },
  'common_sidebar_提交工单': { cn: '提交工单', en: 'Submit ticket' },
  'common_sidebar_after_sales_con': { cn: '售后咨询', en: 'After consulting' },
  'common_sidebar_appointment_to_demonstrate': { cn: '预约演示', en: 'Appoin... demo' },
  'common_sidebar_pre_sales_pp': { cn: '售前服务时间（工作日：9:00-18:30）', en: 'Pre-sale service hours (Working days: 9:00-18:30)' },
  'common_sidebar_after_sales_pp': { cn: '售后服务时间（全天候7*24小时在线）', en: 'After-sales service time (24/7 online)' },
  // 'common_sidebar_to_top': { cn: '', en: '' },
  'common_sidebar_': { cn: '', en: '' },
  'common_sidebar_收起': { cn: '收起', en: 'Put Away' },
  'common_sidebar_展开': { cn: '展开', en: 'Expand' }
}

// empty
const empty = {
  'empty_none': { cn: '暂无{0}', en: 'No {0}' },
  'empty_packages': { cn: '暂无套餐', en: 'No packages' },
  'empty_permissions': { cn: '暂无权限', en: 'No permissions' },
  'empty_data': { cn: '暂无数据', en: 'No data' },
  'empty_announcement': { cn: '暂无公告', en: 'No announcement' },
  'empty_permissions_account_pp': {
    cn: '当前账号无权限，请联系管理员开通',
    en: 'The current account has no permissions, please contact the administrator to open it'
  }
  // 'empty_packages': { cn: '暂无套餐', en: 'No packages' }
}

// 量词|单位
const measure = {
  'measure_day': {
    cn: '0天 | 1天 | {count}天',
    en: 'no days | {count} day | {count} days'
  },
  'measure_order': {
    cn: '0单 | 1单 | {count}单',
    en: 'no orders | {count} order | {count} orders'
  },
  'measure_people': {
    cn: '0人 | 1人 | {count}人',
    en: 'no one | {count} people | {count} people'
  }
}

// 国家|地区
const areas = {
  'area_US_east': { cn: '美东', en: 'US East' },
  'area_US_west': { cn: '美西', en: 'US West' },
  'area_Germany': { cn: '德国', en: 'Germany' },
  'area_UK': { cn: '英国', en: 'UK' },
  'area_CN': { cn: '中国', en: 'China' },
  'area_other': { cn: '其他国家', en: 'Other countries' }
}

const festival = {
  '建军节': { cn: '建军节', en: ' Army Day' },
  '七夕情人节': { cn: '七夕情人节', en: "Chinese Valentine's Day" },
  '教师节': { cn: '教师节', en: "Teachers' Day" },
  '国庆节': { cn: '国庆节', en: 'National Day' },
  '重阳节': { cn: '重阳节', en: 'The Double Ninth Festival' },
  '感恩节': { cn: '感恩节', en: 'Thanksgiving Day' },
  '平安夜': { cn: '平安夜', en: 'Christmas Eve' },
  '圣诞节': { cn: '圣诞节', en: 'Christmas Day' },
  '元旦': { cn: '元旦', en: "New Year's Day" },
  '除夕': { cn: '除夕', en: "Chinese New Year's Eve" },
  '春节': { cn: '春节', en: 'Spring Festival' },
  '情人节': { cn: '情人节', en: "Valentine's Day" },
  '元宵节': { cn: '元宵节', en: 'Lantern Festival' },
  '国际妇女节': { cn: '国际妇女节', en: "International Women's day" },
  '国际植树节': { cn: '国际植树节', en: 'International Arbor Day' },
  '中合节': { cn: '中合节', en: 'Zhonghe Festival' },
  '清明节': { cn: '清明节', en: 'Qingming Festival' },
  '五一国际劳动节': { cn: '五一国际劳动节', en: "International Labor's Day" },
  '五四青年节': { cn: '五四青年节', en: 'Youth Day' },
  '六一国际儿童节': { cn: '六一国际儿童节', en: "International Children's Day" }
}

export default {
  ...conj,
  ...buy,
  ...menu,
  ...home,
  ...areas,
  ...btn,
  ...status,
  ...measure,
  ...empty,
  ...festival,
  ...form,
  ...globalcomp,
  ...sidebar,
  ...login
}
